<template>
  <LoadingBlock :loading="loading">
    <div class="card mb-4">
      <div class="card-body">
        <div class="row gy-3 align-items-end">
          <div class="col-md-6">
            <label class="form-label">Ozon-магазин</label>
            <Select v-model="selectedStoreId" :options="ozonStores" optionLabel="name" optionValue="id"
                    placeholder="Выберите магазин" style="width: 100%" @change="changeStore"/>
          </div>
        </div>

        <div v-if="!ozonStores.length && !loading" class="mt-4 text-muted">
          Ozon-магазины не найдены. Добавьте магазин в разделе «Магазины».
        </div>
      </div>
    </div>

    <template v-if="selectedStoreId">
      <ul class="nav nav-tabs certificate-tabs mb-4">
        <li class="nav-item">
          <a href="#" class="nav-link" :class="{ active: activeOzonTab === 'certificates' }"
             @click.prevent="setOzonTab('certificates')">Сертификаты на Озоне</a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link" :class="{ active: activeOzonTab === 'products' }"
             @click.prevent="setOzonTab('products')">Товары на Озоне</a>
        </li>
      </ul>

      <CertificateOzonCertificates v-if="activeOzonTab === 'certificates'" :store-id="selectedStoreId"/>
      <CertificateOzonProducts v-else :store-id="selectedStoreId"/>
    </template>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Select} from "primevue";
import {stores} from "@/data/store";
import CertificateOzonCertificates from "@/components/certificate/CertificateOzonCertificates.vue";
import CertificateOzonProducts from "@/components/certificate/CertificateOzonProducts.vue";

export default {
  name: "CertificateOzon",
  components: {CertificateOzonProducts, CertificateOzonCertificates, LoadingBlock, Select},
  data() {
    return {
      loading: true,
      ozonStores: [],
      selectedStoreId: '',
    }
  },
  computed: {
    activeOzonTab() {
      return this.$route.query.ozon_tab === 'products' ? 'products' : 'certificates'
    },
  },
  methods: {
    async loadStores() {
      this.loading = true
      const allStores = await stores.getStores()
      this.ozonStores = allStores.filter((store) => store.marketplace === 'ozon')
      this.selectedStoreId = this.$route.query.ozon_store_id || this.ozonStores[0]?.id || ''
      if (this.selectedStoreId && !this.$route.query.ozon_store_id) {
        await this.updateQuery({ozon_store_id: this.selectedStoreId})
      }
      this.loading = false
    },
    async changeStore() {
      await this.updateQuery({ozon_store_id: this.selectedStoreId})
    },
    async setOzonTab(tab) {
      await this.updateQuery({ozon_tab: tab})
    },
    async updateQuery(changes) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...changes,
          tab: 'ozon',
        }
      })
    },
  },
  async mounted() {
    await this.loadStores()
  },
  watch: {
    '$route.query.ozon_store_id'(storeId) {
      if (storeId && storeId !== this.selectedStoreId) {
        this.selectedStoreId = storeId
      }
    },
  },
}
</script>

<style scoped>
.certificate-tabs .nav-link {
  text-transform: none;
}
</style>
